const RADIAN = Math.PI / 180;

const useAdminDashboardDoughnutChart = () => {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  const renderLabel = (props: any) => {
    const { cx, cy, midAngle, innerRadius, outerRadius, index } = props;
    if (index !== 0) return null;

    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return {
      x,
      y,
    };
  };

  return {
    renderLabel,
  };
};

export default useAdminDashboardDoughnutChart;
